import "../css/app.scss";

import Header from "./components/header";
import Burger from "./components/burger";
import LocationMap from "./components/locationMap";
import BrandGallery from "./components/brandGallery";

$(() => {
  const $header = $("header");
  if ($header.length) {
    new Header($header);
  }

  const $burger = $('[data-burger="el"]');
  if ($burger.length) {
    new Burger($burger);
  }

  const $locationMap = $('[data-location-map="el"]');
  if ($locationMap.length) {
    new LocationMap($locationMap);
  }

  const $brandGallery = $('[data-brand-gallery="el"]');
  if ($brandGallery.length) {
    new BrandGallery($brandGallery);
  }
});
